import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton } from 'antd';

import { languages } from '../../../constants/index';
import { changeLang, getLangFromStorage } from '../../../utils';
import { Tooltip } from '..';

export const LanguageSwitcher = ({ ghost }) => {
  const [ t ] = useTranslation();
  const { AR, EN } = languages;
  const langSwitchConfig = {
    ar: EN,
    en: AR
  };
  const setSwitchedLang = () => {
    const switchedLang = langSwitchConfig[getLangFromStorage()];
    changeLang(switchedLang);
  };

  return (
    <Tooltip placement="bottomRight" title={ t('btns.language') }>
      <AntButton shape="circle" icon="global" ghost={ ghost } onClick={ setSwitchedLang } />
    </Tooltip>
  );
};
